"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = CustomDayContent;
var _react = _interopRequireDefault(require("react"));
var _reactDayPicker = require("react-day-picker");
/**
 * Wrap DayContent element to insert custom CSS class name
 * @param {*} props
 * @returns wrapped React element with custom class name "hedtech-day"
 */
function CustomDayContent(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "hedtech-day"
  }, /*#__PURE__*/_react.default.createElement(_reactDayPicker.DayContent, props));
}